/**
 * ---------------------------------------------------------------------------------------------------------------------
 * File khai các hằng số liên quan đến chỉnh UI ------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 *
 * @author admin
 * */



export const STATUS_ACTIVE = 1;
export const STATUS_IN_ACTIVE = 2;

export const STATUSES_NAME: Record<number, string> = {
  [STATUS_ACTIVE]: 'Hoạt động',
  [STATUS_IN_ACTIVE]: 'Ẩn',
}
/**
 * Const size screen ------------------------------------------------------------------------
 * */
// Chiều rộng tối đa vẫn tính là layout mobile
export const SCREEN_MAX_MOBILE = 1200;

/**
 * Const khai báo breakpoints screen theo BS5
 * https://getbootstrap.com/docs/5.0/layout/grid/
 * */
export const SCREEN_GRID_MEDIUM = 768; //  md ≥ 768px Medium (md)
export const SCREEN_GRID_LARGE = 992; // lg ≥ 992px Large (lg)


/**
 * UI Consts ------------------------------------------------------------------------
 * */
export const UI_CONSTS = {
  UI_LAYOUT_MENU_HORIZONTAL: 1, // layout mennu ngang
  UI_LAYOUT_MENU_VERTICAL: 2, // layout menu dọc
  UI_LAYOUT_MENU_HOVER: 1, // menu hover
  UI_LAYOUT_MENU_CLICK: 2, // menu click
  UI_LAYOUT_MENU_FIXED: 1, // menu động
  UI_LAYOUT_MENU_NOT_FIXED: 2, // menu cố định
  UI_LAYOUT_OPEN_PAGE_POPUP: 1, // open page detail popup
  UI_LAYOUT_OPEN_PAGE_NEW: 2, // open page new
  UI_LAYOUT_COLOR_RED: 1, // màu đỏ
  UI_LAYOUT_COLOR_BLACK: 2, // màu đen
  UI_LAYOUT_COLOR_3: 3,
  UI_LAYOUT_COLOR_4: 4,
  UI_LAYOUT_COLOR_5: 5,
  UI_LAYOUT_COLOR_6: 6,
  UI_LAYOUT_COLOR_7: 7,
  UI_LAYOUT_COLOR_8: 8,
  UI_LAYOUT_COLOR_9: 9,
  UI_LAYOUT_COLOR_10: 10,

  UI_LAYOUT_SIDEBAR_RESIZE_NO: 0,
  UI_LAYOUT_SIDEBAR_RESIZE_YES: 1,

  PREFIX_NHANH: 'NVN',
  PREFIX_VPAGE: 'NVP',
  TYPE_CASH: 'cash',
  TYPE_PERCENT: 'percent',
  DECIMAL_ONE: 1,
  DECIMAL_TWO: 2,
  DECIMAL_THREE: 3,
}

export const SETTING_SWITCH = {
  TURN_ON: 1,
  TURN_OFF: 2
};

export const CUSTOM_LOCALE = {
  applyLabel: "Chọn",
  cancelLabel: "Đóng",
  clearLabel: "Xoá",
}

export const EXTENSION = {
  isExisted: false,
  version: 114,
};

export const STATUS_VISIBLE = {
  ACTIVE: 1,
  AWAY: 2,
  DEFAULT: 3,
}
export const PATH_FAVICON_STATUS = {
  ACTIVE: '/img/logo/favicon-blue-dot.svg',
  AWAY: '/img/logo/favicon-yellow-dot.svg',
  DEFAULT: '/img/logo/favicon.svg',
}

export const STATUS_JOIN_SPLIT = {
  NOT_ALLOW: 0,
  JOINED: 1,
  UNJOIN: 2
}

export const SHOPEE_ORDER_STATUS = {
  1: 'READY_TO_SHIP', // sau khi đặt hàng
  2: 'UNPAID', // chưa thanh toán, đối với phương thức thanh toán online, check kèm payment method
  3: '', // sẵn sàng đi giao -> chưa rõ
  4: 'SHIPPED', // bàn giao cho DVVC
  5: 'COMPLETED', // khách nhận đc hàng
  6: 'CANCELLED', // đã bị hủy
  7: 'TO_CONFIRM_RECEIVE', // giao thành công x ngày -> chưa setup đc cronjob
}

export const LAZADA_ORDER_STATUS = {
  1: 'pending', // sau khi đặt hàng
  2: 'unpaid', // chưa thanh toán, đối với phương thức thanh toán online, check kèm payment method
  3: '', // sẵn sàng đi giao -> chưa rõ
  4: 'shipped', // bàn giao cho DVVC
  5: 'delivered', // khách nhận đc hàng
  6: 'canceled', // đã bị hủy
  7: 'confirmed', // giao thành công x ngày -> chưa setup đc cronjob
}

export const SEND_PRIORITY = {
  IMAGE_FIRST: 1,
  TEXT_FIRST: 2,
}

// loại template gửi kèm tin nhắn nhanh
export const TYPE_TEMPLATE_QUICK_MESSAGE = {
  BUTTON_TEMPLATE: 1, // loại button
}

// loại hành động của button template
export const TYPE_SEND_BUTTON_TEMPLATE = {
  FORM_CUSTOM: 1, // gửi form
}


export const EXTENSION_TYPE = {
  IMAGE: ["gif", "jpg", "png", "heic", "jpeg", "tiff", ".bmp"],
  VIDEO: ["mkv", "avi", "rmvb", "mp4", "m4v", "mpg", "mpeg", "3gp", "mov"],
  AUDIO: ["acc", "flac", "m4a", "m4p", "mp3", "wav", "wma"],
  FILE: ["doc", "docx", "pdf", "xlsx", "xlsm", "csv"]
}

export const PAGING_LIMIT_MIN = 10;
export const PAGING_LIMIT_LOW = 20;
export const PAGING_LIMIT_MEDIUM = 30;
export const PAGING_LIMIT_HIGH = 50;
export const PAGING_LIMIT_EXTRA = 100;


